import { SxProps } from '@mui/material';

export const productDetailsThumbnailRibbonsSX: SxProps = {
	position: 'absolute',
	inset: 0,
	zIndex: 1001,
	pointerEvents: 'none',
};
